import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import TableauExplore from "components/Next/Tableau/TableauExplore";

import * as runReducer from "containers/Run/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as wizardReducer from "containers/Wizard/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as predictReducer from "containers/Predict/reducer";
import * as viewReducer from "containers/View/reducer";
import * as globalReducer from "containers/App/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as uploadReducer from "containers/Upload/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as lookerSettingsReducer from "containers/LookerSettings/reducer";

import { PROJECT_MODES } from "containers/Run/reducer";

import { isEnabled } from "utils/featureFlags";

const getNextId = (props) =>
  props && props.nextId !== undefined
    ? props.nextId
    : props && props.match && props.match.params && props.match.params.nextId !== undefined
      ? props.match.params.nextId
      : "new";

class TableauExploreContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};

    props.nextInit(props.datasetId).then(() => {
      props.checkUpdateLooker(props.datasetId, props.nextId);

      props.updateSearchType("Descriptive");

      const searchColumn = props?.match?.params?.searchColumn;
      const searchValue = props?.match?.params?.searchValue;

      if (searchColumn !== undefined && searchValue !== undefined) {
        this.searchWaiter(searchColumn, searchValue);
      }
    });
  }

  searchWaiter(searchColumn, searchValue) {
    const { isExploreReady, updateSearchType, handleSearchInsights } = this.props;

    if (isExploreReady === true) {
      handleSearchInsights([
        {
          filterField: searchColumn,
          filterValue: searchValue,
          label: searchColumn + ": " + searchValue,
          value: searchColumn + ": " + searchValue
        }
      ]);
    } else {
      return setTimeout(() => this.searchWaiter(searchColumn, searchValue), 200);
    }
  }

  render() {
    return this.props.isExploreReady !== true ? (
      <div
        style={{
          height: "calc(100vh - 60px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <LoadingIndicator style={{ margin: "0px" }} />
      </div>
    ) : (
      <TableauExplore {...this.props} />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const nextId = getNextId(ownProps);

  return {
    handleTableauUpload: () => dispatch(loginReducer.handleTableauUpload()),

    handleSearchInsights: (options) => dispatch(nextReducer.handleSearchInsights(nextId, options)),
    updateSearchType: (searchType) => dispatch(nextReducer.updateSearchType(nextId, searchType, false)),
    updateTableauDataId: (tableauDataId) => dispatch(nextReducer.updateTableauDataId(nextId, tableauDataId)),
    nextInit: (datasetId) => dispatch(nextReducer.init(nextId, datasetId, true)),

    createDashboard: () => dispatch(nextReducer.createDashboard(nextId)),
    createFirstDashboard: () => dispatch(nextReducer.createFirstDashboard(nextId)),

    checkUpdateLooker: (datasetId, nextId) => dispatch(homeReducer.checkUpdateLooker(datasetId, nextId)),

    updateIsOpenLookerSettings: (isOpen) => dispatch(lookerSettingsReducer.updateIsOpen(isOpen))
  };
};

const mapStateToProps = (state, ownProps) => {
  const nextId = getNextId(ownProps);
  const datasetId = nextReducer.getDatasetId(state, nextId);

  return {
    nextId: nextId,
    datasetId: datasetId,

    dataset: homeReducer.getDataset(state, datasetId),
    isExploreReady: homeReducer.getIsExploreReady(state, datasetId),

    nextSearchInsights: nextReducer.getSearchInsights(state, nextId),
    pinnedHexList: nextReducer.getPinnedHexList(state, nextId),

    tableauDataId: loginReducer.getTableauDataId(state),
    nextTableauDataId: nextReducer.getTableauDataId(state, nextId),
    isLookerLoading: nextReducer.getIsLookerLoading(state, nextId),
    lookerCount: nextReducer.getLookerCount(state, nextId),

    lookerDashboardElementCount: nextReducer.getLookerDashboardElementCount(state, nextId),
    lookerSDK: loginReducer.getLookerAPIClient(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TableauExploreContainer);
